export const checkAccess = () => {

    const user = JSON.parse(
        sessionStorage.getItem("user")
    );

    // Not logged in
    if (!user) {

        window.dispatchEvent(
            new Event("open-login-modal")
        );

        return false;
    }

    // Payment not active
    if (user.subscription_status !== "active") {

        window.dispatchEvent(
            new Event("open-plan-modal")
        );

        return false;
    }

    return true;
};